<!-- Status colours (red, yellow, etc.) keep raw dark: pairs — semantic tokens would over-abstract per-hue palettes -->
<span
  [ngClass]="{
    'rounded-full': style === 'pill',
    'rounded-md': style === 'badge',
    'bg-surface-hover text-fg-muted ring-outline/20': color === 'grey',
    'bg-red-50 dark:bg-red-900/30 text-red-700 dark:text-red-300 ring-red-600/10': color === 'red',
    'bg-yellow-50 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-300 ring-yellow-600/20':
      color === 'yellow',
    'bg-green-50 dark:bg-green-900/30 text-green-700 dark:text-green-300 ring-green-600/20':
      color === 'green',
    'bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 ring-blue-700/10':
      color === 'blue',
    'bg-indigo-50 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-300 ring-indigo-700/10':
      color === 'indigo',
    'bg-purple-50 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300 ring-purple-700/10':
      color === 'purple',
    'bg-pink-50 dark:bg-pink-900/30 text-pink-700 dark:text-pink-300 ring-pink-700/10':
      color === 'pink',
    'px-2 py-1 text-xs': size === 'small',
    'px-3 py-2 text-sm': size === 'large',
  }"
  class="inline-flex items-center font-medium ring-1 ring-inset whitespace-nowrap"
>
  <ng-content></ng-content>
</span>
